import { BlipChat } from 'blip-chat-widget';
import { widgetHelpCenterKey, widgetHelpCenterUri } from 'app.constants';
import './WidgetHelpCenterView.scss';
import { WidgetConstants, WidgetConstantsTracks } from './WidgetConstants';
export class WidgetHelpDeskController {
    static $inject = ['$translate', 'TranslateService', 'SegmentService'];
    constructor($translate, TranslateService, SegmentService) {
        'ngInject';
        this.$translate = $translate;
        this.TranslateService = TranslateService;
        this.SegmentService = SegmentService;
        this.showMessage = true;
        this.showWidget = true;
        this.openBlipChat = false;
        this.buildChat = false;
        this.isLoading = false;
        this.closeMessageDelay = 2000;
        this.onInit();
    }
    onInit() {
        this.language = this.TranslateService.getCurrentLanguage();
        this.buildWidget();
    }
    async buildWidgetHelpDesk() {
        if (widgetHelpCenterKey === '' || !widgetHelpCenterKey) {
            console.error('Blip chat key not found');
            return;
        }
        const widgetContainer = 'widget-help-center-container';
        const widgetIframe = 'blip-chat-iframe';
        const uriParamsOrigem = '?origem=portal';
        const data = sessionStorage.getItem(WidgetConstants.WIDGET_HELP_CENTER_HAS_SESSION);
        const uri = window.location.href + uriParamsOrigem;
        this.widgetChat = new BlipChat()
            .withAppKey(widgetHelpCenterKey)
            .withCustomMessageMetadata({ pageOrigin: uri })
            .withCustomCommonUrl(widgetHelpCenterUri)
            .withTarget(widgetContainer)
            .withEventHandler(BlipChat.LEAVE_EVENT, async () => {
            await this.closeChat();
            await this.SegmentService.createTrack(WidgetConstantsTracks.HELPDESK_WIDGET_CHAT_CLOSE, {});
        })
            .withEventHandler(BlipChat.LOAD_EVENT, async () => {
            const iframe = document.getElementById(widgetIframe);
            iframe?.contentWindow?.postMessage({ code: WidgetConstants.BLIP_CHAT_SHOW_CLOSE_BUTTON, showCloseButton: true }, iframe?.src);
            if (!data) {
                this.widgetChat.sendMessage({
                    type: 'text/plain',
                    content: this.$translate('widget.messageStart'),
                    metadata: {
                        '#blip.hiddenMessage': true,
                    },
                });
            }
            this.buildChat = true;
            this.isLoading = false;
            sessionStorage.setItem(WidgetConstants.WIDGET_HELP_CENTER_HAS_SESSION, 'true');
            await this.SegmentService.createTrack(WidgetConstantsTracks.HELPDESK_WIDGET_CHAT_OPEN, {});
            this.openBlipChat = true;
        });
        try {
            await this.widgetChat.build();
            const widgetChat = document.getElementById('blip-chat-open-iframe');
            if (widgetChat) {
                widgetChat.setAttribute('style', 'display:none');
            }
        }
        catch (error) {
            this.isLoading = false;
            console.error(error);
        }
    }
    async openChat() {
        if (this.buildChat) {
            this.widgetChat.toogleChat();
            this.openBlipChat = true;
        }
        else {
            this.isLoading = true;
            await this.buildWidgetHelpDesk();
        }
        this.showWidget = true;
    }
    async toogleWidget() {
        const showWidgetBlip = !this.showWidget;
        localStorage.setItem(WidgetConstants.SHOW_WIDGET, `${showWidgetBlip}`);
        await this.SegmentService.createTrack(WidgetConstantsTracks.HELPDESK_WIDGET_BLIP, { showWidgetBlip });
        this.showWidget = showWidgetBlip;
        if (showWidgetBlip) {
            this.closeTimeoutMessageBublle();
            return;
        }
        this.showMessage = false;
    }
    buildWidget() {
        const data = localStorage.getItem(WidgetConstants.SHOW_WIDGET) !== 'false';
        if (!data) {
            this.showWidget = data;
            this.showMessage = false;
            return;
        }
        this.closeTimeoutMessageBublle();
    }
    async closeTimeoutMessageBublle() {
        this.showMessage = true;
        setTimeout(async () => {
            this.showMessage = false;
        }, this.closeMessageDelay);
    }
    async closeChat() {
        this.openBlipChat = false;
        this.closeTimeoutMessageBublle();
    }
}
WidgetHelpDeskController.$inject = ['$translate', 'TranslateService', 'SegmentService'];
